<table  datatable [dtOptions]="dtOptions" class="table table-striped display compact">

    <thead>
      <tr>
        <th >username</th>
        <th >text</th>
        <th >to</th>
        <th >desc</th>
        <th>date</th>
      </tr>

    </thead>


  <tbody>
    <tr *ngFor ="let message  of sentMessageList">
      <td>{{message.username}}</td>
      <td>{{message.text}}</td>
      <td>{{message.toAddress}}</td>
      <td>{{message.description}}</td>
      <td>{{message.dateCreated}}</td>
    </tr>

  </tbody>
</table>
